import { createRoot } from 'react-dom/client';
import { App } from './App.js';

const root = document.getElementById('root');
if (!root) throw new Error('#root element not found');

// StrictMode is intentionally omitted: it double-fires effects which breaks
// the extension bridge's port lifecycle (connect → cleanup → reconnect race).
createRoot(root).render(<App />);
